module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/75/assets/images/f65075fd545b5b0461a7e4f3d6fe5fa0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_crown_medium.svg
// module id = Kc/j
// module chunks = 0